<template>
  <div class="animated fadeIn">
    <b-row class="cert-row">
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong class="certificate-heading">{{ $t('messages.preApprovalCertificate') }}</strong>
            <b-button
              :to="{ name: 'QuickQualifyResult', params: { guid: currentQuickQualification.guid, client: currentQuickQualification.client.id }}"
              class="pull-right button-spacer">
              <i class="fa fa-file"></i> {{ $t('messages.viewCertificate') }}
            </b-button>
          </div>
          <iframe id="FRMXGI" :src="currentQuickQualification.iframe_code" height="1200" width="100%" frameborder="0" scrolling="auto"></iframe>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { DateTime } from 'luxon';
import { mapActions, mapGetters } from 'vuex';
import VueNotifications from 'vue-notifications';

export default {
  name: 'QuickQualifyResult',
  computed: {
      ...mapGetters({
          currentQuickQualification: 'quickQualify/currentQuickQualification',
      }),
  },
}
</script>

<style lang="scss">
@media only screen and (max-width: 767px) {
  .card-footer .btn {
    display: block;
    width: 100%;
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.certificate-heading {
  line-height: 2.5;
}
.cert-row {
  min-width: 1000px;
}
</style>
